import { render, staticRenderFns } from "./vastuuhenkilo-koulutussopimus-form.vue?vue&type=template&id=4b53cb1a&"
import script from "./vastuuhenkilo-koulutussopimus-form.vue?vue&type=script&lang=ts&"
export * from "./vastuuhenkilo-koulutussopimus-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports